import { writable } from "svelte/store";
import type { Suggestion } from "../../common/types";

export const suggestions = writable<Array<Suggestion>>([]);
